import { dismiss, hold, release, useToasts } from '../platform/toast.js';

/**
 * Hinweise unten. R156-08: Sie liegen über fixierten Aktionsleisten (`--werft-bottom-bar`, siehe `useBottomBar`) und
 * über dem sicheren Bereich; am Handy sind höchstens zwei sichtbar (die neuesten). Hinweise nehmen nie den Fokus.
 */
export function Toaster() {
  const toasts = useToasts();
  return (
    <div
      aria-live="polite"
      data-toaster=""
      className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2 px-4"
      style={{ marginBottom: 'calc(var(--werft-bottom-bar, 0px) + env(safe-area-inset-bottom, 0px))' }}
    >
      {toasts.map((x, i) => (
        <div
          key={x.id}
          data-toast=""
          role={x.kind === 'error' ? 'alert' : 'status'}
          // Markieren: ein Klick auf einen Hinweis (z. B. „Rückgängig“) schließt kein offenes Fenster (Sheet)
          onPointerEnter={() => hold(x.id)}
          onPointerLeave={() => release(x.id)}
          onFocus={() => hold(x.id)}
          onBlur={() => release(x.id)}
          onPointerDown={(e) => {
            (e.nativeEvent as PointerEvent & { werftToast?: boolean }).werftToast = true;
          }}
          className={`${i < toasts.length - 2 ? 'max-sm:hidden ' : ''}pointer-events-auto flex max-w-md items-center gap-3 rounded-xl px-4 py-2 text-sm shadow-lg ${
            x.kind === 'error' ? 'bg-red-700 text-white' : x.kind === 'success' ? 'toast-success bg-emerald-800 text-white' : 'bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900'
          }`}
        >
          <span className="min-w-0 flex-1">{x.text}</span>
          {x.action && (
            <button
              className="min-h-9 shrink-0 rounded-lg px-2 font-semibold underline-offset-2 hover:underline"
              onClick={() => {
                x.action!.run();
                dismiss(x.id);
              }}
            >
              {x.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
